import { render, staticRenderFns } from "./LandingHeaderV2.vue?vue&type=template&id=60a20b38&scoped=true&"
import script from "./LandingHeaderV2.vue?vue&type=script&lang=ts&"
export * from "./LandingHeaderV2.vue?vue&type=script&lang=ts&"
import style0 from "./LandingHeaderV2.vue?vue&type=style&index=0&id=60a20b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a20b38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('60a20b38', component.options)
    } else {
      api.reload('60a20b38', component.options)
    }
    module.hot.accept("./LandingHeaderV2.vue?vue&type=template&id=60a20b38&scoped=true&", function () {
      api.rerender('60a20b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/LandingHeaderV2.vue"
export default component.exports